import { render } from "./GuardianGhostModal.vue?vue&type=template&id=2b36ad32&scoped=true"
import script from "./GuardianGhostModal.vue?vue&type=script&lang=js"
export * from "./GuardianGhostModal.vue?vue&type=script&lang=js"

import "./GuardianGhostModal.vue?vue&type=style&index=0&id=2b36ad32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b36ad32"]])

export default __exports__